import * as utils from '@daas-consulting/core-frontend-utils';

export function toPascalCase(input: string): string {
  // return input
  //     .replace(/[^a-zA-Z0-9]+/g, ' ') // Reemplaza todo lo que no sea alfanumérico por espacios
  //     .trim() // Elimina espacios al inicio y final
  //     .split(' ') // Divide en palabras
  //     .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitaliza y lowercases the rest
  //     .join('');
  const arr = input.split(' ');

  let x;
  if (arr.length > 1) {
    const aux = arr.map((x) => x.toLocaleLowerCase()).join(' ');
    x = utils.names.names(aux);
  } else {
    x = utils.names.names(input);
  }

  return x.className;
}
